import { render, staticRenderFns } from "./imgO.vue?vue&type=template&id=370cb696"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('370cb696')) {
      api.createRecord('370cb696', component.options)
    } else {
      api.reload('370cb696', component.options)
    }
    module.hot.accept("./imgO.vue?vue&type=template&id=370cb696", function () {
      api.rerender('370cb696', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/staffCardPlaceholdersNew/imgO.vue"
export default component.exports